const formatUrl = (network, name) => {
  const replaceSpacesWithHyphens = (str) => str.replace(/\s+/g, "-");

  const formattedNetwork = replaceSpacesWithHyphens(name ?? "").toLowerCase();
  const formattedName = replaceSpacesWithHyphens(name ?? "").toLowerCase();

  return `${network}-${formattedName}`;
};

export default formatUrl;
